import { GiphyFetch } from '@giphy/js-fetch-api'

const REACT_APP_GIPHY_TOKEN = process.env.REACT_APP_GIPHY_TOKEN

export const useGiphy = () => {
  const giphy = new GiphyFetch(REACT_APP_GIPHY_TOKEN)

  return { giphy }
}
